import { render, staticRenderFns } from "./articleWork.vue?vue&type=template&id=01c739a3&scoped=true&"
import script from "./articleWork.vue?vue&type=script&lang=js&"
export * from "./articleWork.vue?vue&type=script&lang=js&"
import style0 from "./articleWork.vue?vue&type=style&index=0&id=01c739a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c739a3",
  null
  
)

export default component.exports